import React from 'react';
import ArrowBack from 'material-ui-icons/ArrowBack';
import Button from 'material-ui/Button';

const back = () => {
    window.history.go(-1)
};

class BackButton extends React.Component {
    render() {
        if (!window.location.href.includes('dashboard')) {
            return <Button color="contrast" onClick={back}><ArrowBack /></Button>;
        } else {
            return null;
        }
    }
}

export default BackButton;


// WEBPACK FOOTER //
// ./src/components/BackButton.js